import * as React from 'react';
import styled from '@emotion/styled';
import { StaticQuery, graphql } from 'gatsby';
import GitHubButton from 'react-github-btn';
import Link from './link';
import Loadable from 'react-loadable';
import { useRef } from 'react';
import config from '../../config.js';
import LoadingProvider from './mdxComponents/loading';
import { DarkModeSwitch } from './DarkModeSwitch';

const help = require('./images/help.svg');
const mobbtn = require('./images/mobbtn.svg').default;
const mobbtn1 = require('./images/mobbtn1.svg').default
const isSearchEnabled = config.header.search && config.header.search.enabled ? true : false;

let searchIndices = [];

if (isSearchEnabled && config.header.search.indexName) {
  searchIndices.push({
    name: `${config.header.search.indexName}`,
    title: `Results`,
    hitComp: `PageHit`,
  });
}

import Sidebar from './sidebar';

const LoadableComponent = Loadable({
  loader: () => import('./search/index'),
  loading: LoadingProvider,
});


function myFunction() {
  var x = document.getElementById('navbar');
  var iconbar = document.querySelector('.iconbar');
  if (x.className === 'topnav') {
    x.className += ' responsive';
    x.style.display = 'block';
    iconbar.src = mobbtn1; 
  } else {
    x.className = 'topnav';
    iconbar.src = mobbtn; 
  }
}
function closeNav (){
  var x = document.getElementById('navbar');
  var iconbar = document.querySelector('.iconbar');
  x.className = 'topnav';
  iconbar.src = mobbtn; 
}
const StyledBgDiv = styled('div')`
  height: 84px;
  background-color: #000;
  position: relative;
  display: none;
  background: ${(props) => (props.isDarkThemeActive ? '#001932' : undefined)};

  @media (max-width: 1100px) {
    display: block;
  }
`;
const Header = ({ location, isDarkThemeActive, toggleActiveTheme }) => (
  <StaticQuery
    query={graphql`
      query headerTitleQuery {
        site {
          siteMetadata {
            headerTitle
            githubUrl
            helpUrl
            tweetText
            logo {
              link
              image
            }
            headerLinks {
              link
              text
            }
          }
        }
      }
    `}
    render={(data) => {
      const logoImg = require('./images/logo.svg').default;
      const moblogo = require('./images/moblogo.svg').default;
      const mobbtn = require('./images/mobbtn.svg').default;
      const mobbtn1 = require('./images/mobbtn1.svg').default
      const headerRef = useRef(0);
      const {
        site: {
          siteMetadata: { headerTitle, githubUrl, helpUrl, tweetText, logo, headerLinks },
        },
      } = data;
      const finalLogoLink = logo.link !== '' ? logo.link : '/';
      React.useEffect(()=>{
        var x = document.getElementById('navbar');
        var iconbar = document.querySelector('.iconbar'); 
        if(x.className === 'topnav'){
          iconbar.src = mobbtn;
        }
      })

      React.useEffect(()=>{
        var lg1 = document.querySelector('.img-responsive1')
        var x = document.getElementById('navbar');
        var iconbar = document.querySelector('.iconbar');
        window.onresize = () => { 
          if(window.innerWidth <= 1100){
            x.style.display='none';
            lg1.style.display = 'none';
            iconbar.src = mobbtn; 
          }
          else{
            lg1.style.display = 'flex';
          }
        }
      })

      return (
        <div className={'navBarWrapper'} ref={headerRef}>
          <nav className={'navBarDefault'}>
            <Link to={finalLogoLink} onClick={closeNav}>
              <div className={'navBarHeader'}>
                <div className={'navBarBrand'}>
                  <img
                    className={'img-responsive displayInline'}
                    src={ logoImg }
                    alt={'logo'}
                  />
                  <img
                    className={'img-responsive1'}
                    src={ moblogo }
                    alt={'logo'}
                  />
                </div>
                <div
                  className={'headerTitle displayInline'}
                  dangerouslySetInnerHTML={{ __html: 'MIUI SECURITY WHITE PAPER' }}
                />
              </div>
              {config.header.social ? (
                <ul
                  className="socialWrapper visibleMobileView"
                  dangerouslySetInnerHTML={{ __html: config.header.social }}
                ></ul>
              ) : null}
            </Link>
            <div id="navbar" className={'topnav'}>
              <div className={'visibleMobile'}>
                <Sidebar location={location} onClick={myFunction}/>
                <hr />
              </div>
            </div>
          </nav>
          <StyledBgDiv isDarkThemeActive={isDarkThemeActive}>
            <div className={'navBarDefault removePadd'}>
                <div
                  onClick={myFunction}
                  className={'navBarToggle'}
                  onKeyDown={myFunction}
                  role="button"
                  tabIndex={0}
                >
                  <img className='iconbar'  src={mobbtn}/>
                </div>
              </div>
            </StyledBgDiv>
        </div>
      );
    }}
  />
);

export default Header;
